import React from 'react';
import { Route } from 'react-router';
import Home from './Home';
import ElencoSegnalazioni from './ElencoSegnalazioni';
import Hardware from './Hardware';
import Software from './Software';
import { routes } from '../..';

export default () => (
    <>
        <Route exact path='/portal/chiamate' component={Home} />
        <Route path={routes.core.main + routes.chiamate.hardware} component={Hardware} />
        <Route path={routes.core.main + routes.chiamate.software} component={Software} />
        <Route path={routes.core.main + routes.chiamate.elenco} component={ElencoSegnalazioni} />
    </>
)